import axios, { AxiosResponse, InternalAxiosRequestConfig } from "axios";
import { toast } from "react-toastify";
import { handleDates } from "../utils/dateTime";

export const tokenKey = "token";

axios.defaults.baseURL = process.env.REACT_APP_API_URL;

const handleRequest = (response: InternalAxiosRequestConfig) => {
  handleDates(response.data);
  return response;
};

const handleResponse = (response: AxiosResponse) => {
  handleDates(response.data);
  return response;
};

const handleError = (error: any) => {
  const defaultError = (error: any) => {
    let errorMessage: string;
    if (error.response === undefined) {
      errorMessage = "Възникна комуникационна грешка.";
    } else {
      errorMessage = "Възникна непредвидена грешка.";
    }

    toast.error(`${errorMessage} Моля, опитайте по-късно.`);

    console.log("Server ERROR: ", error.response?.data);
    console.log(JSON.stringify(error));
  };

  if (error.response) {
    switch (error.response.status) {
      case 401: {
        toast.error(`Вашата сесия е изтекла.`);
        localStorage.clear();
        break;
      }
      case 403: {
        toast.error(`Невалидни идентификационни данни за влизане.`);
        localStorage.clear();
        break;
      }
      case 409: {
        toast.error(
          `Документа е редактиран от друг потребител, за да отразите вашите промени е нужно да започнете отначало.`
        );
        break;
      }
      case 422: {
        toast.error(error.response.data);
        break;
      }
      default: {
        defaultError(error);
      }
    }
  } else {
    defaultError(error);
  }

  return Promise.reject(error);
};

axios.interceptors.request.use(
  (config: InternalAxiosRequestConfig) => {
    //config.headers = { Authorization: `Bearer ${localStorage.getItem(tokenKey)}` };
    config.headers.set("Authorization", `Bearer ${localStorage.getItem(tokenKey)}`);
    return config;
  },
  (error) => Promise.reject(error)
);
axios.interceptors.request.use(handleRequest, handleError);
axios.interceptors.response.use(handleResponse, handleError);

export default {
  get: axios.get,
  post: axios.post,
  put: axios.put,
  delete: axios.delete,
};
